import { render } from "./trapezioBlock.vue?vue&type=template&id=054924c6&ts=true"
import script from "./trapezioBlock.vue?vue&type=script&lang=ts"
export * from "./trapezioBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__